import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, AlerteState} from '../types'
import {apiUrl} from '@/config/service'
import axios from 'axios'

type AlerteGetter = GetterTree<AlerteState, RootState>

const state: AlerteState = {
  alertes: null,
  alerte: null
}

export const getters: AlerteGetter = {
  alerteGetter: (state) => state.alerte,
  alertesGetter: (state) => state.alertes
}

export const actions: ActionTree<AlerteState, RootState> = {
  async getAlertesByIdConseillerAction({commit}, id) {
    commit('resetAlertesMutation')
    const {data} = await axios.get(`${apiUrl}/alerte`, {
      params: {
        idConseiller: id,
        action: 'filtre'
      }
    })
    commit('getAlertesByIdConseillerMutation', data)
    return data
  },
  async getAlerteByIdAction({commit}, id) {
    commit('resetAlerteMutation')
    const {data} = await axios.get(`${apiUrl}/alerte/${id}`)
    commit('getAlerteByIdMutation', data)
    return data
  },
  async createAlerteAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/alerte`, formParams)
    return data
  },
  async updateAlerteAction({commit}, {id, formParams}) {
    const {data} = await axios.put(`${apiUrl}/alerte/${id}`, formParams)
    return data
  },
  async deleteAlerteAction({commit}, id) {
    const {data} = await axios.delete(`${apiUrl}/alerte/${id}`)
    return id
  }
}

const mutations: MutationTree<AlerteState> = {
  getAlertesByIdConseillerMutation(state, data) {
    state.alertes = data
  },
  getAlerteByIdMutation(state, data) {
    state.alerte = data
  },
  resetAlertesMutation(state) {
    state.alertes = null
  },
  resetAlerteMutation(state) {
    state.alerte = null
  }
}

export const alerte: Module<AlerteState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
